import { ButtonProps } from '@duxton-web/ui';

export const primaryButtonProps: ButtonProps = {
  type: 'primary',
  size: 'small',
  shape: 'round',
};

export const secondaryButtonProps: ButtonProps = {
  type: 'secondary',
  size: 'small',
  shape: 'round',
};

export const dangerButtonProps: ButtonProps = {
  danger: true,
  size: 'small',
  shape: 'round',
};

export const defaultButtonProps: ButtonProps = {
  size: 'small',
  shape: 'round',
};
